import *  as service from '../services/PianoTechUserServices';

export const FETCH_PIANOTECHUSER_LIST_STARTED = 'FETCH_PIANOTECHUSER_LIST_STARTED';
export const FETCH_PIANOTECHUSER_LIST_SUCCEEDED = 'FETCH_PIANOTECHUSER_LIST_SUCCEEDED';
export const FETCH_PIANOTECHUSER_LIST_FAILED = 'FETCH_PIANOTECHUSER_LIST_FAILED';
export const FIND_PIANOTECHUSER_STARTED = 'FIND_PIANOTECHUSER_STARTED';
export const FIND_PIANOTECHUSER_SUCCEEDED = 'FIND_PIANOTECHUSER_SUCCEEDED';
export const FIND_PIANOTECHUSER_FAILED = 'FIND_PIANOTECHUSER_FAILED';
export const SAVE_PIANOTECHUSER_STARTED = 'SAVE_PIANOTECHUSER_STARTED';
export const SAVE_PIANOTECHUSER_SUCCEEDED = 'SAVE_PIANOTECHUSER_SUCCEEDED';
export const SAVE_PIANOTECHUSER_FAILED = 'SAVE_PIANOTECHUSER_FAILED';
export const RETURN_TO_PIANOTECHUSER_LIST = 'RETURN_TO_PIANOTECHUSER_LIST';
export const SWITCH_EDIT_TYPE = 'SWITCH_EDIT_TYPE';
export const PIANOTECHUSER_MODIFIED = 'PIANOTECHUSER_MODIFIED';
export const PIANOTECHUSER_VALIDATE = 'PIANOTECHUSER_VALIDATE';

function fetchPianoTechUserListSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechUserList = jsonResponse.pianoTechUserList;

    const errorMessage = jsonResponse.errorDescription;
    
    if (errorMessage) {
        return {
            type: FETCH_PIANOTECHUSER_LIST_FAILED,
            message: errorMessage,
        }
    }
    
    return {
        type: FETCH_PIANOTECHUSER_LIST_SUCCEEDED,
        pianoTechUserList
    }
}

function fetchPianoTechUserListFailed(response) {
    const errorMessage = 'Failed to retrieve PianoTechUser list.';

    return {
        type: FETCH_PIANOTECHUSER_LIST_FAILED,
        message: errorMessage
    }
}

export function fetchPianoTechUserList() {
    return dispatch => {
    
        dispatch({
            type: FETCH_PIANOTECHUSER_LIST_STARTED
        });
    
        service
            .getPianoTechUserList()
            .then(resp => {
                dispatch(fetchPianoTechUserListSucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechUserListFailed(error))
            });
    }
}

function findPianoTechUserSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechUser = jsonResponse.pianoTechUser;
    const originalPianoTechUser = Object.assign({}, pianoTechUser);

    const errorMessage = jsonResponse.errorDescription;
    
    if (errorMessage) {
        return {
            type: FIND_PIANOTECHUSER_FAILED,
            message: errorMessage,
        }
    }
    
    return {
        type: FIND_PIANOTECHUSER_SUCCEEDED,
        pianoTechUser,
        originalPianoTechUser,
    }
}

function findPianoTechUserFailed(response) {
    const errorMessage = 'Failed to find PianoTechUser.';

    return {
        type: FIND_PIANOTECHUSER_FAILED,
        message: errorMessage
    }
}

export function findPianoTechUser(userId) {
    return dispatch => {
    
        service
            .findPianoTechUser(userId)
            .then(resp => {
                dispatch(findPianoTechUserSucceeded(resp))
            })
            .catch(error => {
                dispatch(findPianoTechUserFailed(error))
            });
    }
}

function savePianoTechUserSucceeded(response, pianoTechUser) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const message = 'PianoTechUser ' + pianoTechUser.maintenanceType + ' Successful.';
    let updatedPianoTechUser = pianoTechUser;

    const errorMessage = jsonResponse.errorDescription;
    
    if (errorMessage) {
        return {
            type: SAVE_PIANOTECHUSER_FAILED,
            message: errorMessage,
        }
    }
    
    if (jsonResponse.pianoTechUser) {
        updatedPianoTechUser = jsonResponse.pianoTechUser;
    }
    
    return {
        type: SAVE_PIANOTECHUSER_SUCCEEDED,
        pianoTechUser: updatedPianoTechUser,
        message,
    }
}

function savePianoTechUserFailed(response) {
    const errorMessage = 'Action failed: ' + response.message;

    return {
        type: SAVE_PIANOTECHUSER_FAILED,
        message: errorMessage
    }
}

export function savePianoTechUser(pianoTechUser) {
    return dispatch => {
    
        service
            .savePianoTechUser(pianoTechUser)
            .then(resp => {
                dispatch(savePianoTechUserSucceeded(resp,pianoTechUser))
            })
            .catch(error => {
                dispatch(savePianoTechUserFailed(error))
            });
    }
}

